//Type 1

import React, { useState } from "react";
import Styles from "./Fileupload.module.css";
import { ReactComponent as UploadFile } from "../../../assets/images/uploadIcon.svg";
import axios from "axios";
import * as XLSX from "xlsx";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { usePdfPreview } from "../../../hooks/usePdfPreview";
import { useEffect } from "react";
import { getDocumentsDetails } from "../../../Services/BuySell/Listing";
import { useLocation } from "react-router-dom";
import { uploadAuthDocument } from "../../../Services/ApiCalling/Auth";

const Fileupload = ({
  heading,
  value,
  onChange,
  height,
  example,
  type,
  fileType,
  error,
  field,
  id,
  accept,
  disabled,
  viewType,
}) => {
  const location = useLocation();
  const token = useSelector((state) => state?.persistedReducer?.token);
  const [loading, setLoading] = useState(false);
  const [showCheck, setShowCheck] = useState(false);
  const [termsDocumentId, setTermsDocumentId] = useState(null);
  const [fileName, setFileName] = useState("");

  const isInCompanyAdmin =
    location.pathname.includes("/admin_company_dashboard") ||
    location.pathname.includes("company_admin") ||
    location.pathname.includes("companyAdmin") ||
    location.pathname.includes("/admin_dashboard_company") ||
    location.pathname.includes("/register");

  useEffect(() => {
    async function fetchDocumentDetails() {
      if (
        value !== undefined &&
        value !== null &&
        value !== "" &&
        typeof value !== "object"
      ) {
        const aa = await getDocumentsDetails(value);
        setFileName(aa?.data?.filename);
      }
    }
    fetchDocumentDetails();
  }, [value]);

  useEffect(() => {
    if (value && typeof value === "object" && value.id) {
      setTermsDocumentId(value.id);
      setShowCheck(true);
    } else if (typeof value === "string" || typeof value === "number") {
      setTermsDocumentId(value);
      setShowCheck(true);
    }
  }, [value]);

  const handleUploadFile = async (event) => {
    const files = event.target.files;
    if (!files || files.length === 0) {
      console.error("No file selected for upload.");
      return;
    }

    const selectedFile = files[0];

    if (isInCompanyAdmin || location.pathname.includes("/register")) {
      if (
        selectedFile.type !== "application/pdf" &&
        !selectedFile.name.toLowerCase().endsWith(".pdf")
      ) {
        toast.error("Only PDF files are allowed for document uploads.");
        return;
      }
    }

    if (accept && selectedFile) {
      const acceptedTypes = accept
        .split(",")
        .map((type) => type.trim().toLowerCase());
      const fileName = selectedFile.name.toLowerCase();
      const fileType = selectedFile.type.toLowerCase();

      const isAccepted = acceptedTypes.some((type) => {
        if (type.startsWith(".")) {
          return fileName.endsWith(type);
        }
        return fileType === type;
      });

      if (!isAccepted) {
        toast.error("Selected file type is not allowed.");
        return;
      }
    }

    if (fileType === "excel") {
      const reader = new FileReader();
      reader.onload = (e) => {
        const binaryStr = e.target.result;
        const data = new Uint8Array(binaryStr);
        const workbook = XLSX.read(data, { type: "array" });
        workbook.SheetNames.forEach((sheetName) => {
          const sheetData = XLSX.utils.sheet_to_json(
            workbook.Sheets[sheetName]
          );
          onChange(sheetData);
        });
      };
      reader.readAsArrayBuffer(selectedFile);
      return;
    }

    const form = new FormData();
    form.append("file", selectedFile);
    const url = `${process.env.REACT_APP_API_URL}/doc/upload/public/random/AUTH`;

    try {
      setLoading(true);
      const response = await axios.post(url, form, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `${token}`,
        },
      });
      if (response?.data?.code === 200) {
        onChange({
          field: field,
          id: response?.data?.data?.id,
          fileName: selectedFile?.name,
        });
        setFileName(selectedFile?.name);
        setTermsDocumentId(response?.data?.data?.id);
        toast.success("File uploaded successfully");
        setShowCheck(true);
      } else {
        setShowCheck(false);
        console.error(
          "File upload failed with response code:",
          response?.data?.code
        );
      }
    } catch (error) {
      toast.error("Error during file upload");
      console.error("Error during file upload:", error);
    } finally {
      setLoading(false);
    }
  };

  const { handlePreviewGeneralTerms, PdfPreviewModal } = usePdfPreview();

  return (
    <div className={Styles.inputTextContainer}>
      <PdfPreviewModal />
      {heading && (
        <div className={Styles.inputHeading}>
          {heading}
          {loading && (
            <span className={Styles.loaderSpinner} style={{ marginLeft: 8 }}>
              <span />
            </span>
          )}

          {showCheck && !isInCompanyAdmin && (
            <span
              type="button"
              onClick={() => {
                handlePreviewGeneralTerms(termsDocumentId);
              }}
              className={Styles.checkIcon}
            >
              <RemoveRedEyeIcon
                style={{ fontSize: "15px", color: "var(--primary-color-text)" }}
              />
            </span>
          )}
        </div>
      )}
      <div
        className={viewType === 2 ? Styles.viewType2 : Styles.inputFile}
        style={{ height: `${height ? height : 32}px` }}
      >
        <input
          disabled={disabled}
          type="file"
          accept={accept}
          onChange={handleUploadFile}
          id={id}
        />
        <label
          style={{ backgroundColor: disabled ? "#e8e9e8" : "" }}
          className={viewType === 2 ? Styles.viewType2Label : Styles.inputLabel}
          htmlFor={id}
        >
          <UploadFile style={{ height: viewType === 2 ? "25px" : "20px" }} />
          <span>{fileName || example}</span>
        </label>
      </div>
      {error && <div className={Styles.errorHeading}>{error}</div>}
    </div>
  );
};

export default Fileupload;
